
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_46134","data-name":"Group 46134","xmlns":"http://www.w3.org/2000/svg","width":"55","height":"55"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15528","data-name":"Rectangle 15528","width":"15","height":"15","transform":"translate(20 20)","fill":"#fff","stroke":"#707070","stroke-width":"1"}})])]),_c('rect',{attrs:{"id":"Rectangle_15467","data-name":"Rectangle 15467","width":"55","height":"55","rx":"17","fill":"#def3f3"}}),_c('g',{attrs:{"id":"Mask_Group_22195","data-name":"Mask Group 22195","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_29921","data-name":"Path 29921","d":"M2.72 2.152a.568.568 0 01.568.568v.409l1.4-.348a7.388 7.388 0 015.1.559l.082.041a6.251 6.251 0 004.229.494l2.356-.555a.568.568 0 01.7.614 36.21 36.21 0 000 7.833.568.568 0 01-.435.615l-2.365.555a7.388 7.388 0 01-5-.583l-.082-.041a6.251 6.251 0 00-4.312-.478l-1.669.417v4.1a.569.569 0 01-1.137 0V2.72a.568.568 0 01.572-.568z","transform":"translate(17.852 17.962)","fill":"#4ec0bf","fill-rule":"evenodd"}})])])
          )
        }
      }
    